import { EditableFieldsByBlockType, ContentBlockTypes, EditableFields } from './types';

export function humanizedBlockType(type: string) {
  return type.replace('ContentBlock::', '');
}

export function getPermissionsByBlockType(blockType: ContentBlockTypes): EditableFields {
  return PERMISSIONS_BY_BLOCK_TYPE[blockType];
}

const PERMISSIONS_BY_BLOCK_TYPE: EditableFieldsByBlockType = {
  'ContentBlock::LessonBlock': {
    lessonPicker: true,
    name: true
  },
  'ContentBlock::PracticeSessionBlock': {
    includeOldPrompts: true,
    itemCount: true,
    quizMode: true,
    estimatedTimeMinutes: true,
    itemType: true,
    examSectionPicker: true,
    promptPickerStrategy: true,
    accessLevel: true,
    name: true,
    slug: true
  },
  'ContentBlock::SubjectMasteryRoot': {
    manageChildBlocks: true
  },
  'ContentBlock::SubjectMasteryGroup': {
    name: true,
    slug: true,
    manageChildBlocks: true
  },
  'ContentBlock::AssignmentGroup': {
    name: true,
    slug: true,
    addAssignmentBlockChild: true,
    addSectionedAssignmentBlockChild: true,
    manageChildBlocks: true
  },
  'ContentBlock::SubjectMasteryBlock': {
    name: true,
    slug: true,
    addLessonChild: true,
    addPracticeSessionChild: true,
    manageChildBlocks: true,
    difficultySelector: true,
    accessLevel: true
  },
  'ContentBlock::AssignmentBlock': {
    name: true,
    slug: true,
    addLessonChild: true,
    addPracticeSessionChild: true,
    manageChildBlocks: true,
    difficultySelector: true,
    accessLevel: true
  },
  'ContentBlock::SectionedAssignmentBlock': {
    name: true,
    slug: true,
    manageChildBlocks: true,
    accessLevel: true
  },
  'ContentBlock::Container': {
    name: true,
    slug: true,
    manageChildBlocks: true,
    addPracticeSessionChild: true,
    addLessonChild: true,
    addJsonBlockChild: true,
    addContainerBlockChild: true,
    addStudyScheduleBlockChild: true,
    addReviewBlockChild: true,
    addExternalResourceBlockChild: true,
    addRichTextBlockChild: true
  },
  'ContentBlock::JSONBlock': {
    name: true,
    slug: true,
    payload: true
  },
  'ContentBlock::LearningSessionBlock': {
    addExternalResourceBlockChild: true,
    addLessonChild: true,
    addPracticeSessionChild: true,
    addReviewBlockChild: true,
    addLessonSeriesLinkBlockChild: true,
    addGreSegmentLinkBlockChild: true,
    addGreMixedPracticeLinkBlockChild: true,
    addFlashcardsDeckBlockChild: true,
    manageChildBlocks: true,
    name: true,
    slug: true
  },
  'ContentBlock::StudyScheduleBlock': {
    accessLevel: true,
    addLearningSessionBlockChild: true,
    experienceLevels: true,
    manageChildBlocks: true,
    minDaysUntilTest: true,
    numMonths: true,
    description: true,
    name: true,
    learningSessionSetName: true,
    learningSessionsPerSet: true,
    learningSessionName: true,
    examSectionFocus: true
  },
  'ContentBlock::ReviewBlock': {
    estimatedTimeMinutes: true,
    name: true
  },
  'ContentBlock::ExternalResourceBlock': {
    estimatedTimeMinutes: true,
    name: true,
    url: true,
    description: true,
    examSectionPicker: true
  },
  'ContentBlock::DiagnosticTestBlock': {
    addDiagnosticSectionChild: true,
    manageChildBlocks: true
  },
  'ContentBlock::DiagnosticSectionBlock': {
    addPracticeSessionChild: true,
    manageChildBlocks: true
  },
  'ContentBlock::AssessmentBlock': {
    manageChildBlocks: true,
    displayName: true,
    maximumEngagementHours: true,
    minimumEngagementHours: true
  },
  'ContentBlock::MockTestSectionBlock': {
    manageChildBlocks: false,
    questions: true
  },
  'ContentBlock::StudyModuleBlock': {
    manageChildBlocks: true,
    slug: true
  },
  'ContentBlock::DrillBlock': {
    manageChildBlocks: false,
    includeOldPrompts: true,
    itemCount: true,
    quizMode: true,
    estimatedTimeMinutes: true,
    itemType: true,
    examSectionPicker: true,
    promptPickerStrategy: true,
    accessLevel: true,
    name: true,
    slug: true
  },
  'ContentBlock::LessonSeriesBlock': {
    name: true,
    slug: true,
    lessons: true,
    manageChildBlocks: true,
    addDrillBlockChild: true,
    blurb: true
  },
  'ContentBlock::LessonSeriesLinkBlock': {
    lessonSeriesSlug: true
  },
  'ContentBlock::GRE::CurriculumRootBlock': {
    manageChildBlocks: true
  },
  'ContentBlock::GRE::SectionBlock': {
    manageChildBlocks: true,
    addGreSubsectionBlockChild: true
  },
  'ContentBlock::GRE::SubsectionBlock': {
    name: true,
    easeOfLearningFactor: true,
    frequencyFactor: true,
    manageChildBlocks: true,
    addGreSegmentBlockChild: true
  },
  'ContentBlock::GRE::SegmentBlock': {
    name: true,
    description: true,
    significanceFactor: true,
    targetAbility: true,
    manageChildBlocks: true,
    addGreSliceBlockChild: true
  },
  'ContentBlock::GRE::SliceBlock': {
    name: true,
    manageChildBlocks: true,
    addLessonChild: true,
    addGreSlicePracticeBlockChild: true,
    addGreAdaptiveSlicePracticeBlockChild: true
  },
  'ContentBlock::GRE::SlicePracticeBlock': {
    manageChildBlocks: true,
    estimatedTimeMinutes: true,
    addGreExercisePracticeBlockChild: true,
    addGreDrillPracticeBlockChild: true,
    addGreTestlikePracticeBlockChild: true
  },
  'ContentBlock::GRE::AdaptiveSlicePracticeBlock': {
    manageChildBlocks: true,
    estimatedTimeMinutes: true,
    addGreConceptPracticeBlockChild: true,
    addGreTestlikePracticeBlockChild: true
  },
  'ContentBlock::GRE::DrillPracticeBlock': {
    itemType: true,
    itemCount: true,
    promptPickerStrategy: true,
    includeOldPrompts: true,
    quizMode: true,
    examSectionPicker: true
  },
  'ContentBlock::GRE::ExercisePracticeBlock': {
    itemType: true,
    itemCount: true,
    promptPickerStrategy: true,
    includeOldPrompts: true,
    quizMode: true,
    examSectionPicker: true
  },
  'ContentBlock::GRE::ConceptPracticeBlock': {
    itemType: true,
    itemCount: true,
    promptPickerStrategy: true,
    includeOldPrompts: true,
    quizMode: true,
    examSectionPicker: true
  },
  'ContentBlock::GRE::TestLikePracticeBlock': {
    itemType: true,
    itemCount: true,
    promptPickerStrategy: true,
    includeOldPrompts: true,
    quizMode: true,
    examSectionPicker: true
  },
  'ContentBlock::GRE::SegmentLinkBlock': {
    segmentPicker: true,
    name: true,
    slug: true,
    optional: true
  },
  'ContentBlock::GRE::MixedPracticeLinkBlock': {
    mixedPracticePicker: true,
    name: true,
    accessLevel: true,
    slug: true
  },
  'ContentBlock::FlashcardsDeckBlock': {
    name: true,
    accessLevel: true,
    slug: true,
    estimatedTimeMinutes: true,
    examSectionPicker: true
  },
  'ContentBlock::OfficialQuestionsSectionBlock': {
    name: true,
    accessLevel: true,
    slug: true,
    manageChildBlocks: true
  },
  'ContentBlock::RichTextBlock': {
    richText: true
  }
};
